<template>
  <div class="reg_form_box">
    <template v-if="form_step == 1">
      <div class="reg_form_box_title agent_form_pat_title">
        <h1>Let’s collect seller information.</h1>
      </div>
      <form action="#" method="post">
        <div class="sell_home_form_box">
          <div class="sell_home_form" id="form3">
            <div class="form-row">
              <div class="col-md-12 mb-4">
                <div class="input_star">
                  <input
                    type="text"
                    class="form-control"
                    placeholder="Seller name"
                    name="seller_name"
                    v-model="seller_name"
                  />
                  <span>
                    <i class="fas fa-info-circle"></i> Add all sellers name seperated with comma.
                  </span>
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="col-md-12 mb-4">
                <div class="input_star">
                  <input
                    type="text"
                    class="form-control"
                    placeholder="Street Address"
                    name="street_address"
                    v-model="street_address"
                  />
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="col-md-12 mb-4">
                <input
                  type="text"
                  class="form-control"
                  placeholder="Unit (If Apartment)"
                  name="units"
                  v-model="units"
                />
              </div>
            </div>
            <div class="form-row">
              <div class="col-md-12">
                <div class="form_submit_button">
                  <button
                    type="button"
                    @click="handleFormStep"
                    :disabled="formOneInvalid"
                    :style="formOneInvalid ? 'opacity:0.6;cursor:not-allowed;' : ''"
                  >
                    Continue
                    <span>
                      <i class="fas fa-chevron-right"></i>
                    </span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </template>
    <template v-else-if="form_step == 2">
      <div class="reg_form_box_title agent_form_pat_title">
        <h1>Let’s get the price information’s</h1>
      </div>
      <form action="#" method="post">
        <div class="sell_home_form_box">
          <div class="sell_home_form" id="form3">
            <div class="form-row">
              <div class="col-md-12 mb-4">
                <div class="input_star">
                  <input
                    type="text"
                    class="form-control"
                    placeholder="List price (your expected price)"
                    name="list_price"
                    v-model="list_price"
                  />
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="col-md-12 mb-4">
                <div class="input_star">
                  <input
                    type="text"
                    class="form-control"
                    placeholder="Current Tax"
                    name="current_tax"
                    v-model="current_tax"
                  />
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="col-md-12 mb-4">
                <input
                  type="text"
                  class="form-control"
                  placeholder="Lot size (Optional)"
                  name="lot_size"
                  v-model="lot_size"
                />
              </div>
            </div>
            <div class="form-row">
              <div class="col-md-12">
                <div class="form_submit_button">
                  <button type="button" class="form_back prev_form1" @click="backFormStep">
                    <span>
                      <i class="fas fa-chevron-left"></i>
                    </span> Back
                  </button>
                  <button
                    type="button"
                    @click="handleFormStep"
                    :disabled="formTwoInvalid"
                    :style="formTwoInvalid ? 'opacity:0.6;cursor:not-allowed;' : ''"
                  >
                    Continue
                    <span>
                      <i class="fas fa-chevron-right"></i>
                    </span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </template>
    <template v-else-if="form_step == 3">
      <div class="reg_form_box_title agent_form_pat_title">
        <h1>What is your home building type?</h1>
      </div>
      <form action="#" method="post">
        <div class="form-row">
          <div class="col-md-12 mb-4">
            <div class="custom-control custom-radio">
              <input
                type="radio"
                id="customRadio4"
                name="building_type"
                v-model="building_type"
                class="custom-control-input"
                value="Detached"
              />
              <label class="custom-control-label" for="customRadio4">Detached</label>
            </div>
            <div class="custom-control custom-radio">
              <input
                type="radio"
                id="customRadio5"
                name="building_type"
                v-model="building_type"
                class="custom-control-input"
                value="Semi detached"
              />
              <label class="custom-control-label" for="customRadio5">Semi detached</label>
            </div>
            <div class="custom-control custom-radio">
              <input
                type="radio"
                id="customRadio6"
                name="building_type"
                v-model="building_type"
                class="custom-control-input"
                value="Town house"
              />
              <label class="custom-control-label" for="customRadio6">Town house</label>
            </div>
            <div class="custom-control custom-radio">
              <input
                type="radio"
                id="customRadio7"
                name="building_type"
                v-model="building_type"
                class="custom-control-input"
                value="Apartment"
              />
              <label class="custom-control-label" for="customRadio7">Apartment</label>
            </div>
          </div>
          <div class="col-md-12">
            <div class="form_submit_button">
              <button type="button" class="form_back prev_form1" @click="backFormStep">
                <span>
                  <i class="fas fa-chevron-left"></i>
                </span> Back
              </button>
              <button
                type="button"
                @click="handleFormStep"
                :disabled="formThreeInvalid"
                :style="formThreeInvalid ? 'opacity:0.6;cursor:not-allowed;' : ''"
              >
                Continue
                <span>
                  <i class="fas fa-chevron-right"></i>
                </span>
              </button>
            </div>
          </div>
        </div>
      </form>
    </template>
    <template v-else-if="form_step == 4">
      <div class="reg_form_box_title agent_form_pat_title">
        <h1>Who is occupying the house?</h1>
      </div>
      <form action="#" method="post">
        <div class="form-row">
          <div class="col-md-12 mb-4">
            <div class="custom-control custom-radio">
              <input
                type="radio"
                id="customRadio4"
                name="house_occupy"
                v-model="house_occupy"
                class="custom-control-input"
                value="Vacant"
              />
              <label class="custom-control-label" for="customRadio4">Vacant</label>
            </div>
            <div class="custom-control custom-radio">
              <input
                type="radio"
                id="customRadio5"
                name="house_occupy"
                v-model="house_occupy"
                class="custom-control-input"
                value="Tenant"
              />
              <label class="custom-control-label" for="customRadio5">Tenant</label>
            </div>
            <div class="custom-control custom-radio">
              <input
                type="radio"
                id="customRadio6"
                name="house_occupy"
                v-model="house_occupy"
                class="custom-control-input"
                value="Owner"
              />
              <label class="custom-control-label" for="customRadio6">Owner</label>
            </div>
            <div class="custom-control custom-radio">
              <input
                type="radio"
                id="customRadio7"
                name="house_occupy"
                v-model="house_occupy"
                class="custom-control-input"
                value="Pre-Construction"
              />
              <label class="custom-control-label" for="customRadio7">Pre-Construction</label>
            </div>
          </div>
          <div class="col-md-12">
            <div class="form_submit_button">
              <button type="button" class="form_back prev_form1" @click="backFormStep">
                <span>
                  <i class="fas fa-chevron-left"></i>
                </span> Back
              </button>
              <button
                type="button"
                @click="handleFormStep"
                :disabled="formFourInvalid"
                :style="formFourInvalid ? 'opacity:0.6;cursor:not-allowed;' : ''"
              >
                Continue
                <span>
                  <i class="fas fa-chevron-right"></i>
                </span>
              </button>
            </div>
          </div>
        </div>
      </form>
    </template>
    <template v-if="form_step == 5">
      <div class="reg_form_box_title agent_form_pat_title">
        <h1>Let’s verify some fact about your home</h1>
      </div>
      <form action="#" method="post">
        <div class="sell_home_form_box">
          <div class="sell_home_form" id="form3">
            <div class="form-row">
              <div class="col-md-12 mb-4">
                <div class="custom-control" style="padding-left: 0">
                  <div class="input_star">
                    <select name="bed" class="form-control" id="bed" v-model="bed">
                      <option :value="''" :disabled="true">How many bedrooms</option>
                      <option value="Studio">Studio</option>
                      <option value="1">1</option>
                      <option value="2">2</option>
                      <option value="3">3</option>
                      <option value="4">4</option>
                      <option value="5">5</option>
                      <option value="6">6</option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="col-md-12 mb-4">
                <div class="custom-control" style="padding-left: 0">
                  <div class="input_star">
                    <select name="bath" class="form-control" id="bath" v-model="bath">
                      <option :value="''" :disabled="true">How many bathrooms</option>
                      <option value="1">1</option>
                      <option value="2">2</option>
                      <option value="3">3</option>
                      <option value="4">4</option>
                      <option value="5">5</option>
                      <option value="6">6</option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="col-md-12 mb-4">
                <input
                  type="text"
                  class="form-control"
                  placeholder="Built year (optional)"
                  name="built_year"
                  v-model="built_year"
                />
              </div>
              <div class="col-md-12 mb-4">
                <input
                  type="text"
                  class="form-control"
                  placeholder="Enter square footage (optional)"
                  name="square_footage"
                  v-model="square_footage"
                />
              </div>
              <div class="col-md-12">
                <div class="form_submit_button">
                  <button type="button" class="form_back prev_form1" @click="backFormStep">
                    <span>
                      <i class="fas fa-chevron-left"></i>
                    </span> Back
                  </button>
                  <button
                    type="button"
                    @click="handleFormStep"
                    :disabled="formFiveInvalid"
                    :style="formFiveInvalid ? 'opacity:0.6;cursor:not-allowed;' : ''"
                  >
                    Continue
                    <span>
                      <i class="fas fa-chevron-right"></i>
                    </span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </template>
    <template v-if="form_step == 6">
      <div class="reg_form_box_title agent_form_pat_title">
        <h1>Let’s verify some fact about your home</h1>
      </div>
      <form action="#" method="post">
        <div class="sell_home_form_box">
          <div class="sell_home_form" id="form3">
            <div class="form-row">
              <div class="col-md-12 mb-4">
                <div class="custom-control custom-radio">
                  <input
                    type="radio"
                    id="customRadio4"
                    name="parking_space"
                    v-model="parking_space"
                    class="custom-control-input"
                    value="garage"
                  />
                  <label class="custom-control-label" for="customRadio4">Garage</label>
                </div>
                <div class="custom-control custom-radio">
                  <input
                    type="radio"
                    id="customRadio4"
                    name="parking_space"
                    v-model="parking_space"
                    class="custom-control-input"
                    value="carport"
                  />
                  <label class="custom-control-label" for="customRadio4">Carport</label>
                </div>
                <div class="custom-control custom-radio">
                  <input
                    type="radio"
                    id="customRadio4"
                    name="parking_space"
                    v-model="parking_space"
                    class="custom-control-input"
                    value="none"
                  />
                  <label class="custom-control-label" for="customRadio4">None of the above</label>
                </div>
              </div>
              <div class="col-md-12">
                <div class="form_submit_button">
                  <button type="button" class="form_back prev_form1" @click="backFormStep">
                    <span>
                      <i class="fas fa-chevron-left"></i>
                    </span> Back
                  </button>
                  <button
                    type="button"
                    @click="handleFormStep"
                    :disabled="formSixInvalid"
                    :style="formSixInvalid ? 'opacity:0.6;cursor:not-allowed;' : ''"
                  >
                    Continue
                    <span>
                      <i class="fas fa-chevron-right"></i>
                    </span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </template>
    <template v-if="form_step == 7">
      <div class="reg_form_box_title agent_form_pat_title">
        <h1>What is the status of your basement?</h1>
      </div>
      <form action="#" method="post">
        <div class="sell_home_form_box">
          <div class="sell_home_form" id="form3">
            <div class="form-row">
              <div class="col-md-12 mb-4">
                <div class="custom-control custom-radio">
                  <input
                    type="radio"
                    id="customRadio4"
                    name="basement"
                    v-model="basement"
                    class="custom-control-input"
                    value="Finished"
                  />
                  <label class="custom-control-label" for="customRadio4">Finished</label>
                </div>
                <div class="custom-control custom-radio">
                  <input
                    type="radio"
                    id="customRadio4"
                    name="basement"
                    v-model="basement"
                    class="custom-control-input"
                    value="Finished Apartment"
                  />
                  <label class="custom-control-label" for="customRadio4">Finished Apartment</label>
                </div>
                <div class="custom-control custom-radio">
                  <input
                    type="radio"
                    id="customRadio4"
                    name="basement"
                    v-model="basement"
                    class="custom-control-input"
                    value="Partially Finished"
                  />
                  <label class="custom-control-label" for="customRadio4">Partially Finished</label>
                </div>
                <div class="custom-control custom-radio">
                  <input
                    type="radio"
                    id="customRadio4"
                    name="basement"
                    v-model="basement"
                    class="custom-control-input"
                    value="Unfinished"
                  />
                  <label class="custom-control-label" for="customRadio4">Unfinished</label>
                </div>
                <div class="custom-control custom-radio">
                  <input
                    type="radio"
                    id="customRadio4"
                    name="basement"
                    v-model="basement"
                    class="custom-control-input"
                    value="No Basement"
                  />
                  <label class="custom-control-label" for="customRadio4">No Basement</label>
                </div>
              </div>
              <div class="col-md-12">
                <div class="form_submit_button">
                  <button type="button" class="form_back prev_form1" @click="backFormStep">
                    <span>
                      <i class="fas fa-chevron-left"></i>
                    </span> Back
                  </button>
                  <button
                    type="button"
                    @click="handleFormStep"
                    :disabled="formSevenInvalid"
                    :style="formSevenInvalid ? 'opacity:0.6;cursor:not-allowed;' : ''"
                  >
                    Continue
                    <span>
                      <i class="fas fa-chevron-right"></i>
                    </span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </template>
    <template v-else-if="form_step == 8">
      <div class="reg_form_box_title agent_form_pat_title">
        <h1>What is the status of your basement?</h1>
      </div>
      <form action="#" method="post">
        <div class="sell_home_form_box">
          <div class="sell_home_form" id="form3">
            <div class="form-row">
              <div class="col-md-12 mb-4">
                <div class="input_star">
                  <textarea
                    rows="5"
                    class="form-control"
                    placeholder="Detailed Description"
                    name="detailed_description"
                    v-model="detailed_description"
                  ></textarea>
                </div>
              </div>
              <div class="col-md-12">
                <div class="form_submit_button">
                  <button type="button" class="form_back prev_form1" @click="backFormStep">
                    <span>
                      <i class="fas fa-chevron-left"></i>
                    </span> Back
                  </button>
                  <button
                    type="button"
                    @click="handleFormStep"
                    :disabled="formEightInvalid"
                    :style="formEightInvalid ? 'opacity:0.6;cursor:not-allowed;' : ''"
                  >
                    Continue
                    <span>
                      <i class="fas fa-chevron-right"></i>
                    </span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </template>
    <template v-else-if="form_step == 9">
      <div class="reg_form_box_title agent_form_pat_title">
        <h1>Signup to Continue</h1>
        <div class="form-row">
          <div class="col-md-12 mb-4">
            <input type="hidden" />
            <span style="color:#707070;">
              <i class="fas fa-info-circle"></i> If you already have an account, please
              <a href="/login">Login to Continue</a>
            </span>
          </div>
        </div>
      </div>
      <form action="#" method="post">
        <div class="sell_home_form_box">
          <div class="sell_home_form" id="form3">
            <div class="form-row">
              <div class="col-md-12 mb-4">
                <div class="input_star">
                  <input
                    type="text"
                    class="form-control"
                    v-model="full_name"
                    name="full_name"
                    placeholder="Full Name"
                  />
                </div>
              </div>
              <div class="col-md-12 mb-4">
                <div class="input_star">
                  <input
                    type="text"
                    class="form-control"
                    v-model="email"
                    name="email"
                    placeholder="Email"
                  />
                </div>
              </div>
              <div class="col-md-12 mb-4">
                <div class="input_star">
                  <input
                    type="text"
                    class="form-control"
                    v-model="phone_number"
                    name="phone_number"
                    placeholder="Phone Number (10 digits only)"
                  />
                </div>
              </div>
              <div class="col-md-12">
                <div class="form_submit_button">
                  <button
                    type="button"
                    @click="submitSellerLeadForm"
                    :disabled="formNineInvalid || processing"
                    :style="formNineInvalid || processing ? 'opacity:0.6;cursor:not-allowed;' : ''"
                  >
                  <template v-if="processing">
                    Processing...
                  </template>
                  <template v-else>
                    Continue
                    <span>
                      <i class="fas fa-chevron-right"></i>
                    </span>
                  </template>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </template>
  </div>
</template>

<script>
import {
  required,
  email,
  minLength,
  maxLength
} from "vuelidate/lib/validators";
import Swal from "sweetalert2/dist/sweetalert2.js";
import "sweetalert2/src/sweetalert2.scss";
export default {
  name: "SellerLeadForm",
  data() {
    return {
      form_step: 1,
      seller_name: "",
      street_address: "",
      units: "",
      list_price: "",
      current_tax: "",
      lot_size: "",
      building_type: "",
      house_occupy: "",
      bed: "",
      bath: "",
      built_year: "",
      square_footage: "",
      parking_space: "",
      basement: "",
      detailed_description: "",
      full_name: "",
      email: "",
      phone_number: "",
      processing: false
    };
  },
  mounted() {
      this.$v.$touch();
  },
  validations: {
    seller_name: {
      required
    },
    street_address: {
      required
    },
    list_price: {
      required
    },
    current_tax: {
      required
    },
    building_type: {
      required
    },
    house_occupy: {
      required
    },
    bed: {
      required
    },
    bath: {
      required
    },
    parking_space: {
      required
    },
    basement: {
      required
    },
    detailed_description: {
      required
    },
    full_name: {
      required
    },
    email: {
      required,
      email
    },
    phone_number: {
      required,
      minLength: minLength(10),
      maxLength: maxLength(10)
    }
  },
  computed: {
    formOneInvalid() {
      if (this.$v.$invalid) {
        if (this.$v.seller_name.$error) {
          return true;
        } else if (this.$v.street_address.$error) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    formTwoInvalid() {
      if (this.$v.$invalid) {
        if (this.$v.list_price.$error) {
          return true;
        } else if (this.$v.current_tax.$error) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    formThreeInvalid() {
      if (this.$v.$invalid) {
        if (this.$v.building_type.$error) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    formFourInvalid() {
      if (this.$v.$invalid) {
        if (this.$v.house_occupy.$error) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    formFiveInvalid() {
      if (this.$v.$invalid) {
        if (this.$v.bed.$error) {
          return true;
        } else if (this.$v.bath.$error) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    formSixInvalid() {
      if (this.$v.$invalid) {
        if (this.$v.parking_space.$error) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    formSevenInvalid() {
      if (this.$v.$invalid) {
        if (this.$v.basement.$error) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    formEightInvalid() {
      if (this.$v.$invalid) {
        if (this.$v.detailed_description.$error) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    formNineInvalid() {
      if (this.$v.$invalid) {
        if (this.$v.full_name.$error) {
          return true;
        } else if (this.$v.email.$error) {
          return true;
        } else if (this.$v.phone_number.$error) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    }
  },
  methods: {
    handleFormStep() {
      this.form_step = this.form_step + 1;
    },
    backFormStep() {
      if (this.form_step > 1) {
        this.form_step = this.form_step - 1;
      }
    },
    submitSellerLeadForm() {
        this.processing = true;
        
        const formData = new FormData();

        formData.append("seller_name", this.seller_name);
        formData.append("address", this.street_address);
        formData.append("unitno", this.units);
        formData.append("list_price", this.list_price);
        formData.append("current_tax", this.current_tax);
        formData.append("lot_size", this.lot_size);
        formData.append("building_type", this.building_type);
        formData.append("house_occupy", this.house_occupy);
        formData.append("no_of_bedrooms", this.bed);
        formData.append("no_of_fullbathrooms", this.bath);
        formData.append("no_of_partialbathrooms", this.bath);
        formData.append("kitchen_counter_top", "None");
        formData.append("relationship", "None");
        formData.append("issues_related_to", "None");
        formData.append("paint_color", "None");
        formData.append("paint_color_condition", "None");
        formData.append("swimming_pool", "None");
        formData.append("sale_timeline", "None");
        formData.append("built_year", this.built_year);
        formData.append("area_in_sqft", this.square_footage);
        formData.append("parking_space", this.parking_space);
        formData.append("basement", this.basement);
        formData.append("extra_info", this.detailed_description);
        formData.append("contact_name", this.full_name);
        formData.append("contact_email", this.email);
        formData.append("contact_phone", this.phone_number);

        axios.post("/post-seller-lead", formData)
        .then(response => {
            let msg = "Congrats! You have successfully submitted your data.";
            if (response?.data?.message) {
                msg = response.data.message;
            }
            this.form_step = 1;
            this.seller_name = "";
            this.street_address = "";
            this.units = "";
            this.list_price = "";
            this.current_tax = "";
            this.lot_size = "";
            this.building_type = "";
            this.house_occupy = "";
            this.bed = "";
            this.bath = "";
            this.built_year = "";
            this.square_footage = "";
            this.parking_space = "";
            this.basement = "";
            this.detailed_description = "";
            this.full_name = "";
            this.email = "";
            this.phone_number = "";

            this.$v.$touch();
            Swal.fire({
                title: msg,
                icon: "success",
                confirmButtonText: "Okay",
                timer: 3000
            });
        }).catch(error => {
            let message = "Unable to submit data.";
            if (error?.response?.data?.message) {
                message = error.response.data.message;
            }
            Swal.fire({
                title: message,
                icon: "error",
                confirmButtonText: "I understand!",
                timer: 3000
            });
        }).finally(res => {
            this.processing = false;
        });
    }
  }
};
</script>
